import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaHandPointRight } from 'react-icons/fa';
import { ROUTES } from '../../assets/constants/strings';
import Sad from '../../assets/images/sad.svg';

import './style.scoped.scss';
import config from '../../config';

const ErrorFrame = () => {
  const reasons = [
    'You have reached your amount of pages view for the current period.',
    'The document or page was removed from the site',
    'Your connection has timed out',
    `You've misspelled the URL`,
    `You don't have access to this document`,
  ];
  return (
    <div id='error-frame'>
      <img src={Sad} alt='Oops' />
      <h3 className='mb-0 mt-3'>
        Something went wrong while loading RegulationCity
      </h3>
      <h4 className='my-2'>Possible Issues</h4>

      {reasons.map((reason, i) => (
        <span key={i}>
          <FaHandPointRight />
          {reason}
        </span>
      ))}

      <span className='my-3'>Either refresh the screen to try again or</span>
      <Link to={ROUTES.HOME} className='wf-submit'>
        <FaHome className='mr-3' />
        Go to the Home page
      </Link>
      <span>If you keep seeing this error, please</span>
      <a
        href={`${config.WordPressURL}help/`}
        target='_blank'
        rel='noreferrer'
        className='my-account-btn secondary'
      >
        Contact Us
      </a>
    </div>
  );
};

export default ErrorFrame;
